import styled from 'styled-components';

export const AddNewtableContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  button {
    height: 35px;
    padding-top: 0;
    text-decoration: underline;
  }
`;

export const TableStatus = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 13px;
  color: ${({ $occupied }) => ($occupied ? '#854d0e' : '#166534')};
  background: ${({ $occupied }) => ($occupied ? '#fef3c7' : '#dcfce7')};
`;
